// extracted by mini-css-extract-plugin
module.exports = {"userForm":"UserForm_userForm__3UPvN","upload":"UserForm_upload__1lasb","fadeIn":"UserForm_fadeIn__38jRS","scaleXin":"UserForm_scaleXin__1r2HJ"};